/**
 * Created by shikha on 02/15/2019.
 */

export class CreepyCarnivalTwoStrings {

    public static AS_PROMISED: string = "As Promised...";
    public static FREE_STAR_SPIN: string = "Here is your free Star Spin!";
    public static HIGH_VALUE_SYMBOLS: string = "13 high value symbols and 2 wilds…";
    public static NEXT_TIME: string = "Spin now for a free win and see you next time!";
    public static STAR_SPIN: string = "Star Spin ";

    public static FS_YOU_WON_TEXT: string = "Lucky You! You've just won";
    public static NUMBER_OF_SPINS_WON_TEXT: string = "Freespins!";
    public static FS_MULTIPLIER_TEXT: string = "Start spinning now for a 5 times win multiplier";
    public static FS_BETLINES_TEXT: string = "and 20 extra betlines!";
    public static FS_SCATTER_TEXT: string = "Any 2 scatters on any spin";
    public static FS_EXTRA_FREESPINS_TEXT: string = "will give you 3 extra Freespins!";

    public static FS_OUTRO_EXIT_TEXT: string = "That's all for this round!";
    public static FS_OUTRO_WON_TEXT: string = "You just won";
    public static FS_OUTRO_WHOA_TEXT: string = "... Whoa!";
}